module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chno"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("1")])]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('p', {
    staticClass: "chtitle"
  }, [_c('i', [_vm._v("Unconventional Maestro")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/com.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quoteti"
  }, [_vm._v("To say that Busoni was a teacher, is both an understatement and an overstatement, depending upon one’s viewpoint. In the sense of guiding a pupil’s technical and artistic problems in a steadily progressive manner, he was not a teacher at all. But in the higher sense of imparting to a pupil a consummate understanding of art, and the need for cultural and spiritual completion, he was the most inspiring teacher of our time.")]), _vm._v(" "), _c('p', {
    staticClass: "qcenter"
  }, [_vm._v("Egon Petri, “How Ferruccio Busoni Taught”")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("HOW BUSONI TAUGHT COMPOSITION: THE MUSIC OF THE MASTERS AS MODELS")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("AS A TEACHER")]), _vm._v(" of composition, Busoni imparted his vision of great music to his students, even if he did not require the systematic completion of exercises to improve technical skill."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1_1",
      "id": "fn1_1"
    }
  }, [_vm._v("1")]), _vm._v(" When he did give practical musical advice, it was based on the music of the masters—especially the compositions of Johann Sebastian Bach and Wolfgang Amadeus Mozart. He disliked abstract exercises, and instead encouraged students to devise their own technical drills from other compositions. Score study was therefore a major part of his instruction, as he encouraged students to seek out and study unfamiliar music, as well as to thoroughly parse well-known pieces. Bach’s music was used to teach counterpoint, fugue, and variation form, while Mozart was a model for opera and orchestration. Bach’s Passacaglia in C Minor for Organ, BWV 582, the Chaconne from the Violin Sonata in D Minor, BWV 1004, and the Aria mit 30 Veränderungen, BWV 988 "), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("(“Goldberg Variations”) served as examples of variation form. Busoni also revealed characteristics in the music that he considered to be timeless and universal, such as the counterpoint.")])]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("Busoni’s only important surviving “composition treatise,” if it can be called that, his edition of Bach’s "), _c('i', [_vm._v("Das Wohltemperierte Klavier")]), _vm._v(", book II, BWV 870–893, is neither systematic nor comprehensive. First published in 1915, it represents his attempt to illuminate principles of good composition derived from Bach’s preludes and fugues. As such, it contrasts considerably with his edition of "), _c('i', [_vm._v("Das Wohltemperierte Klavier")]), _vm._v(", book I, BWV 846–869 (1894), in which he sought to illustrate masterful keyboard technique. Busoni described his aims for book II in the preface: “As editor I have devoted some diligence to establishing a definite connection between prelude and fugue, occasionally showing this by means of examples. In the later examples I believe I have overstepped Bach’s intentions. All changes and additions, however, follow the educational intention of giving the learner an insight into the mechanism of the composition.”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1_2",
      "id": "fn1_2"
    }
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("One of the principles Busoni sought to illustrate using Bach fugues as examples was the close relationship between the subject and overall form. Similarly, he focused on thematic interrelatedness between the preludes and fugues. Organic connectedness was a key component of his compositional ideal, and Bach served as a prime example for him. For instance, he noted thematic connections between the Prelude and Fugue no. 2 in C Minor, BWV 871, even if, as he noted, the interrelatedness might have been unintentional."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1_3",
      "id": "fn1_3"
    }
  }, [_vm._v("3")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Busoni was especially interested in explicating the exceptions Bach made to generally accepted contemporaneous practices of counterpoint and fugal writing. He claimed that some foreshadowed practices of his own era: “In the present-day art of composition, which is descended in a straight line from that of Bach (in so far as it strives more and more consciously through polyphony to become feeling in sound) the course of moving towards the middle point of the modulation circle—dependence on key—and objective symbolism both fall out of the plan which makes way for the subjective temperament. Consequently the Master’s rights have been extended; he may now take possession of the Bach exceptions as rules.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1_4",
      "id": "fn1_4"
    }
  }, [_vm._v("4")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Throughout the edition, he considered form, motivic treatment, counterpoint, and scoring. In Prelude no. 1 in C Minor, BWV 870, for instance, he wrote about Bach’s ability to evoke unusual sonorities through spacing "), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("and registration. He specifically mentioned that Bach’s treatment of register and voicing creates unusual timbral effects, such as the evocation of manual changes on the organ."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1_5",
      "id": "fn1_5"
    }
  }, [_vm._v("5")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Busoni also taught about form, counterpoint, thematic construction, and scoring through extensive commentary. In Prelude no. 3 in C-Sharp Major, BWV 872, for instance, he analyzed and divided the form into sections, showed thematic relationships between the main sections, and suggested instrumental doublings evoking the sonority of a string quintet (see "), _c('a', {
    attrs: {
      "href": "#/xhtml/#ex1_1"
    }
  }, [_vm._v("music example 1.1")]), _vm._v(")."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1_6",
      "id": "fn1_6"
    }
  }, [_vm._v("6")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If Busoni included his own ideas in commentary, he also encouraged his students to be active learners by creating personal composition exercises based on Bach’s music; he illustrated the process with several of his own composition etudes. For instance, he showed how to study the fugal subject by separating the voices onto separate staves with Fugue no. 2 in C Minor, BWV 871 (see "), _c('a', {
    attrs: {
      "href": "#/xhtml/#ex1_2"
    }
  }, [_vm._v("music example 1.2")]), _vm._v(")."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1_7",
      "id": "fn1_7"
    }
  }, [_vm._v("7")])]), _vm._v(" In another exercise, he rewrote Bach to illustrate the construction of good melodic material and included his own revised version alongside Bach’s as a point of comparison. In Prelude no. 3 in C-Sharp Major, BWV 872, for instance, he “reconstructed” the final bars, relying in part on an older version of the prelude, in which some of the harmonies were notated using only block chords. All three voices contain notes that are altered in terms of pitch and register, although rhythmic similarities persist in the bass, and the rhythm of constant sixteenth notes remains unaltered. He felt his version was better (!) than Bach’s, but left it up to the student to determine why (see "), _c('a', {
    attrs: {
      "href": "#/xhtml/#ex1_3"
    }
  }, [_vm._v("music example 1.3")]), _vm._v(")."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1_8",
      "id": "fn1_8"
    }
  }, [_vm._v("8")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For Busoni, transcription was also important for the educational process, as was a study of a piece’s genealogy and transformation. Bach had learned composition by transcribing the works of others, and Busoni taught his students to do the same. He encouraged them to become more critical composers by identifying multiple ways of approaching the same piece. Thus, in his edition, he did not seek to provide a single definitive version, but included multiple versions of Bach’s preludes when available, such as the Prelude no. 5 in D Minor, BWV 874.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("While Busoni used Bach’s pieces as models for form, counterpoint, and thematic interrelatedness, he relied on Mozart’s music as a model for orchestration. In an age dominated by Mahlerian and Wagnerian lushness, his call to return to Mozartian principles of orchestration was unconventional. For Busoni, Mozart was the ideal orchestrator. He claimed that all orchestral works needed to directly refer back to Mozart. Busoni especially admired Mozart’s approach toward spacing and voice leading, which contributed to transparent but resonant textures that took advantage of diverse instrumental timbres and colors:"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1_9",
      "id": "fn1_9"
    }
  }, [_vm._v("9")])])]), _vm._v(" "), _c('div', {
    staticClass: "cap"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _c('a', {
    attrs: {
      "id": "ex1_1"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/ex1_1.png"
    }
  })])]), _c('a', {
    attrs: {
      "id": "ex1_1"
    }
  }, [_c('p', {
    staticClass: "figcaption"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("MUSIC EXAMPLE 1.1")]), _vm._v(". Busoni’s adaptation of and commentary about J. S. Bach’s Prelude no. 3 in C-Sharp Major, BWV 872, from "), _c('i', [_vm._v("The Well-Tempered Clavier")]), _vm._v(", book II. The German text can be translated as follows: “This prelude consists of a first section of twice three bars, a second section of four times two bars, and a return of twice three bars, before a group of four other bars that lead to a fughetta. The fughetta, a tripartite design, is made up of 9, 7, and 10 measures: exposition, development, and coda in miniature. The melodic line of the uppermost notes of the soprano at the end of the first and second parts of the prelude is the source of the fughetta theme—a hidden relationship you should not ignore. In order to enhance the sound, the doubling of the bass or of the middle would create a good effect, whereby one generally recalls the soft tone of the violas and cellos in the string quintet.”")])])]), _c('a', {
    attrs: {
      "id": "ex1_1"
    }
  }), _c('div', {
    staticClass: "cap"
  }, [_c('a', {
    attrs: {
      "id": "ex1_1"
    }
  }), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "ex1_1"
    }
  }), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _c('a', {
    attrs: {
      "id": "ex1_2"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/ex1_2.png"
    }
  })])]), _c('a', {
    attrs: {
      "id": "ex1_2"
    }
  }, [_c('p', {
    staticClass: "figcaption"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("MUSIC EXAMPLE 1.2")]), _vm._v(". Busoni’s re-staving of J. S. Bach’s Fugue no. 2 in C Minor, BWV 871, from "), _c('i', [_vm._v("The Well-Tempered Clavier")]), _vm._v(", book II. A translation of the footnote is as follows: “This composition study seeks to present a clear depiction of all the thematic voices, expose their meaning in their original context, as well as demonstrate the perfection of the four voices in the exposition. Through this study, "), _c('span', {
    staticClass: "underline"
  }, [_vm._v("the meaning of all fragmentations and transformations [of the subject]")]), _vm._v(" are brought to consciousness. The subject is made evident by slurs.”")])])]), _c('a', {
    attrs: {
      "id": "ex1_2"
    }
  }), _c('div', {
    staticClass: "cap"
  }, [_c('a', {
    attrs: {
      "id": "ex1_2"
    }
  }), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "ex1_2"
    }
  }), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _c('a', {
    attrs: {
      "id": "ex1_3"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/ex1_3.png"
    }
  })])]), _c('a', {
    attrs: {
      "id": "ex1_3"
    }
  }, [_c('p', {
    staticClass: "figcaption"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("MUSIC EXAMPLE 1.3")]), _vm._v(". Busoni’s reworked version of the end of the ending of Prelude no. 3 in C-Sharp Major, BWV 872, from J. S. Bach’s "), _c('i', [_vm._v("Well-Tempered Clavier")]), _vm._v(", book II. A translation of the note is as follows: “We seek to reconstruct the thematic idea, whose structure is subsumed in the chromatic melody, and to portray a version in the following example that captures a middle ground between the older version and the main text.”")])])]), _c('a', {
    attrs: {
      "id": "ex1_3"
    }
  }), _c('p', {
    staticClass: "quote"
  }, [_c('a', {
    attrs: {
      "id": "ex1_3"
    }
  }, [_vm._v("Hardly explored yet today are the secrets of spacing in Mozart’s works. Broadly demonstrated: a) the influence of voice leading on the choice of instrumentation. Mozart often uses double counterpoint. This causes the most striking feature of his scores: the leading voice is simultaneously above and below the accompaniment (or the other way around); b) his pedal notes; c) the wide position in the strings; a free space to give the harmonies room to breathe, in other words allowing space for the overtones of the lower voices, including the unimposing horns and bassoons. An important point: melodic strings always play through closed chords in the brass, not the other way around, because doubling ")]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("in order to penetrate is foreign to Mozart. He would double something only to achieve a distinct instrumental color (e.g., flutes and oboes, flutes and bassoons, etc.) or to support the dynamic intensification of a theme."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1_10",
      "id": "fn1_10"
    }
  }, [_vm._v("10")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Orchestration was an integral (rather than ancillary) part of the compositional process for Busoni, and he spent much time with his students discussing the topic, frequently using Mozart as the main example. He was known to ask students to orchestrate a passage from a Mozart concerto and then compare their versions to the original. Selden-Goth describes one such assignment that included orchestrating sixty-four bars of a piano arrangement of a Mozart concerto without looking first at the complete score. Then students compared their version with Mozart’s in order to better understand the techniques of the master. The goal was not to imitate Mozart, but rather, by comparing solutions, to gain a richer vision of the possibilities of orchestration. He urged his students to systematically repeat this process until they understood the intricacies of Mozart’s orchestrations."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1_11",
      "id": "fn1_11"
    }
  }, [_vm._v("11")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Busoni considered writing an orchestration treatise relying on ideas from Mozart, Wagner, and his own experience, and he published an outline in 1905, but he never completed the project. Even so, the 1905 draft, and subsequent detailed unpublished sketches recorded in Philipp Jarnach’s handwriting, provide a good idea as to the advice he gave to composition students. In particular, he stressed the connectedness of the instruments, stating that they should function like a single unit, like a piano with an expansive register, yet with the added advantage of differing timbral qualities. He maintained that all the instrument types should regularly participate, that there should not be long stretches of music featuring a single orchestral group. He thought spatially when discussing register, and he sought to counter the notion that soft dynamics required few instruments. Most importantly, he discussed what he called “absolute instrumentation,” that is, when the timbre is viewed as essential to a work’s identity—as opposed to the view that instrumentation can be added at the end of the compositional process."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1_12",
      "id": "fn1_12"
    }
  }, [_vm._v("12")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mozart served as a model not only for orchestration, but also for dramatic principles. Busoni encouraged his students to study Mozart’s operas, in particular, "), _c('i', [_vm._v("Die Zauberflöte, Le Nozze di Figaro")]), _vm._v(", and "), _c('i', [_vm._v("Don Giovanni")]), _vm._v("."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1_13",
      "id": "fn1_13"
    }
  }, [_vm._v("13")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("He turned to Mozart for models of dramatic pacing, characterization of characters, and stylistic heterogeneity.")])]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("Although Bach and Mozart were the main composers that Busoni covered with his composition students, he also referred to Italian opera composers, especially Bellini, Donizetti, and Verdi, as models of melodic writing. For Busoni, melody was the fundamental building block of music from which the harmony could be organically derived. Yet although he admired the long melodies of the Italian opera masters, he also began developing his own theories about melody and harmonic derivation not long after learning of Bernhard Ziehn’s principles of melodic and harmonic integration from Frederick Stock in Chicago: “This ‘absolute’ melody, at first a self-sufficient formation, united itself subsequently with accompanying harmony, and later melted with it into oneness; out of this oneness the continually progressive poly-harmony aims to free and liberate itself.”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1_14",
      "id": "fn1_14"
    }
  }, [_vm._v("14")])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("HOW BUSONI TAUGHT COMPOSITION: SCORE CRITIQUE")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("If Busoni’s students studied the music of the masters, they also clamored for his comments on their work. He looked at the scores of his pupils, sometimes right away, while at other times he would keep the scores and look at them in private. He did not always notate comments in the scores; he often provided suggestions in person or in letters, and he would frequently relate the comments to his aesthetic vision of music. On the other hand, he sometimes rewrote whole passages. According to Stuckenschmidt, Walther Geiser once brought him a score; he took it, disappeared, and came back having rewritten and orchestrated it."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1_15",
      "id": "fn1_15"
    }
  }, [_vm._v("15")])]), _vm._v(" Busoni was more than happy to critique scores even after his students had moved away, either in person during visits or via mail, and in that way he maintained lasting relationships with many of them. Guerrini, for instance, only studied with the composer in Bologna from 1913 to 1914, but he continued sending pieces to him until Busoni’s death in 1924. Busoni reportedly responded with detailed and insightful comments."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1_16",
      "id": "fn1_16"
    }
  }, [_vm._v("16")])]), _vm._v(" Dieren also bought pieces to Busoni for advice, including a piano piece on March 11, 1912."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1_17",
      "id": "fn1_17"
    }
  }, [_vm._v("17")])]), _vm._v(" Letters between Dieren and Busoni that span from 1910 to 1921 provide some evidence of suggestions about compositions. When Dieren asked for advice about "), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("opera, Busoni suggested that it needs to be based on fantastic subjects (as opposed to historical figures, which—according to Busoni—must not sing)."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1_18",
      "id": "fn1_18"
    }
  }, [_vm._v("18")]), _vm._v(" In 1913, the two discussed Dieren’s first string quartet and plans for a second quartet."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1_19",
      "id": "fn1_19"
    }
  }, [_vm._v("19")])]), _vm._v(" In 1919, Dieren sent Busoni the score of a composition entitled "), _c('i', [_vm._v("Carnavalesque")]), _vm._v(", which he had dedicated to him. Busoni specifically praised the transparency of the orchestration."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1_20",
      "id": "fn1_20"
    }
  }, [_vm._v("20")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Some of the most detailed surviving records of Busoni’s score critiques appear in the form of two pages of manuscript paper featuring comments about compositions by Louis Gruenberg, who studied with him in Berlin."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1_21",
      "id": "fn1_21"
    }
  }, [_vm._v("21")])]), _vm._v(" When Gruenberg submitted a piano sonata for critique, Busoni responded on August 11, 1908, with copious suggestions. In addition to requesting orthographic clarification, he also sketched out possible alternative realizations. On a separate page, he offered ideas about instrumentation and texture for an unspecified orchestral piece from around the same time period, including that the unbroken fugal subject at the beginning of the scherzo would be better served by more contrapuntal movement. In another passage, he suggested a scoring of cellos, trombones, and basses. To add greater spirit to the finale, he encouraged Gruenberg to score the trumpets one octave higher (see "), _c('a', {
    attrs: {
      "href": "#/xhtml/#fig1_1"
    }
  }, [_vm._v("figure 1.1")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("HOW BUSONI TAUGHT COMPOSITION: AESTHETIC VISION")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("If Busoni imparted practical ideas about the craft of composition through the lens of music masterpieces and score critique, he shared his esoteric vision of music through conversations during private lessons or social gatherings. In addition, students read his published writings about music."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1_22",
      "id": "fn1_22"
    }
  }, [_vm._v("22")])]), _vm._v(" For most of his students, it was his aesthetic ideas that had the greatest impact.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("These ideas were informed by an intellectual culture that included German idealists, such as Arthur Schopenhauer (1788–1860), who preached the preeminence of music and its close association with nature, as well as the writings of Johann Wolfgang von Goethe (1749–1832) and Fried-rich Nietzsche (1844–1900), whose ideas about organicism and eternal reoccurrence were foundational for Busoni’s theories of form and Young Classicality."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1_23",
      "id": "fn1_23"
    }
  }, [_vm._v("23")])]), _vm._v(" German Romantic authors, such as E.T.A. Hoffmann, who glorified the fantastic, also informed his theories about opera. In addition, his ideas were impacted by contemporaneous artistic movements, including Futurism and "), _c('i', [_vm._v("Jugendstil")]), _vm._v(". Like others influenced by the brief "), _c('i', [_vm._v("Jugendstil")]), _vm._v(" movement, Busoni wanted to break away from traditional forms and move to a more organic and abstract art characterized by color, uniqueness, and asymmetry."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1_24",
      "id": "fn1_24"
    }
  }, [_vm._v("24")])]), _vm._v(" His contributions to the magazine "), _c('i', [_vm._v("Pan")]), _vm._v(", which was published in Berlin from 1895 to 1900 and again from 1910 to 1915, reveal direct connections to the movement. Along with other "), _c('i', [_vm._v("Jugendstil")]), _vm._v(" authors, poets, and artists, he published his ideas at least three times in the magazine from 1911 to 1912."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1_25",
      "id": "fn1_25"
    }
  }, [_vm._v("25")])]), _vm._v(" Although not an advocate of noise music, like Luigi Russolo (1885–1947) nor interested in making a complete break with music of the past, as many Futurists were, he nevertheless also embraced the Futurist fascination with new technology. As a friend of Umberto Boccioni (1882–1916), Busoni had ample time to exchange ideas with Futurists.")]), _vm._v(" "), _c('div', {
    staticClass: "cap"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _c('a', {
    attrs: {
      "id": "fig1_1"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/fig1_1.png"
    }
  })])]), _c('a', {
    attrs: {
      "id": "fig1_1"
    }
  }, [_c('p', {
    staticClass: "figcaption"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("FIGURE 1.1")]), _vm._v(". Busoni, notes for Gruenberg’s sonata-in-progress. Private collection of Joan Gruenberg Cominos, Martinez, CA.")])])]), _c('a', {
    attrs: {
      "id": "fig1_1"
    }
  }), _c('p', {
    staticClass: "indentb"
  }, [_c('a', {
    attrs: {
      "id": "fig1_1"
    }
  }), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("As a syncretist, Busoni’s ideas were inclusive. Consequently, his instruction was rarely dogmatic. It often took the form of witty dialogues between teacher and pupil in the manner of Plato. He did not want to impose opinions on students in an authoritarian manner, but he did make his views known. At the same time, he welcomed differences of opinion, and he often talked about composers and pieces from diverse vantage points, thus resulting in seemingly paradoxical or inconsistent points of view. One conversation with Dieren began with Verdi’s "), _c('i', [_vm._v("Falstaff")]), _vm._v(" and ended with Puccini’s "), _c('i', [_vm._v("Madama Butterfly")]), _vm._v(", but turned to Beethoven and Liszt in the middle. The two discussed orchestration and staging, among other topics:")])]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("BUSONI:")]), _vm._v("  I am looking for the first time at a full score of "), _c('i', [_vm._v("Falstaff")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("MYSELF:")]), _vm._v("  Oh! Ah!")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("B")]), _vm._v(".  I am greatly disappointed.")]), _vm._v(" "), _c('p', {
    staticClass: "hanga"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("M")]), _vm._v(".  !?!")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("B")]), _vm._v(".  Honestly—don’t be upset—his brass writing is too…")]), _vm._v(" "), _c('p', {
    staticClass: "hanga"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("M")]), _vm._v(".  Oh, please don’t. Think of the richness…")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("B")]), _vm._v(".  Yes, but perhaps that reminds me too much of the Italian brass band of his day. That is what he imagined; that is what he wrote for.")]), _vm._v(" "), _c('p', {
    staticClass: "hanga"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("M")]), _vm._v(".  Can’t we give him the benefit of the doubt, and believe he foresaw what sound we should hear later?")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("B")]), _vm._v(".  Let us—but what about the “one-two-three,” “one-two-three”?")])]), _c('p', {
    staticClass: "hang"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("M")]), _vm._v(".  What about the agonizing brass of the “Emperor” Concerto, and those recurring entries in imitation?")])]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("B")]), _vm._v(".  "), _c('i', [_vm._v("(who has just played the work)")]), _vm._v(" Let’s not talk about it. But what do you think of the other work on the programme, I mean the “Totentanz”?")]), _vm._v(" "), _c('p', {
    staticClass: "hanga"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("M")]), _vm._v(".  I think Liszt…")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("B")]), _vm._v(".  Yes, I know all that—one time I think he is more than capable, more capable than anyone has need to be, and at other times that he is technically not quite competent. What "), _c('i', [_vm._v("is")]), _vm._v(" one to think?")]), _vm._v(" "), _c('p', {
    staticClass: "hanga"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("M")]), _vm._v(".  That is not what people like or disdain him for. See how they are all crazy about Puccini now; here is a modicum of incompetence for you all the time, and yet…")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("B")]), _vm._v(".  All the same, last season when I was in Milan I walked in at the opera and I heard “Butterfly”—and it was all so well put on and so well done; I thought it was really quite charming.")])]), _c('p', {
    staticClass: "hangb"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("M")]), _vm._v(".  !!!"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1_26",
      "id": "fn1_26"
    }
  }, [_vm._v("26")])]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("In yet another conversation, they discussed orchestration and registration based on Wagner’s "), _c('i', [_vm._v("Tristan")]), _vm._v(" prelude. Busoni’s disdain for Wagner’s writing, which he considered formulaic, is thinly veiled by sarcasm:")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("MYSELF:")]), _vm._v("  I have been carefully studying the “Tristan” Prelude today.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("BUSONI")]), _vm._v(".  And…")]), _vm._v(" "), _c('p', {
    staticClass: "hanga"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("M")]), _vm._v(".  One must admit…")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("B")]), _vm._v(".  Ah, mustn’t one…")]), _vm._v(" "), _c('p', {
    staticClass: "hanga"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("M")]), _vm._v(".  Only, when one by one they all come in doing the same thing.—these crushing, crashing octaves…")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("B")]), _vm._v(".  Oh, but you must leave him that. That was his special acoustic discovery. One can understand his making the most of the sonority he got by it."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1_27",
      "id": "fn1_27"
    }
  }, [_vm._v("27")])])]), _vm._v(" "), _c('p', {
    staticClass: "indentt"
  }, [_vm._v("Topics were not just focused on music. Busoni took a holistic approach, teaching that the artist needed more than technical prowess to write masterpieces. He had to be a well-rounded "), _c('i', [_vm._v("mensch")]), _vm._v(", with a rich understanding of the humanities—especially literature, architecture, and the other arts."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1_28",
      "id": "fn1_28"
    }
  }, [_vm._v("28")])]), _vm._v(" Busoni had wide-ranging interests, and he tried to expand the intellectual and artistic horizons of his students—he disliked focusing merely on craftsmanship."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1_29",
      "id": "fn1_29"
    }
  }, [_vm._v("29")])]), _vm._v(" Discussions often turned to Goethe’s "), _c('i', [_vm._v("Faust")]), _vm._v(", Miguel de Cervantes’s "), _c('i', [_vm._v("Don Quixote")]), _vm._v(", or other important pieces of literature. Dieren remembers, for instance, how one conversation that started with "), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("Giacomo Meyerbeer shifted to Hector Berlioz and ended with references to English literature and culture."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1_30",
      "id": "fn1_30"
    }
  }, [_vm._v("30")]), _vm._v(" Guerrini similarly recalls that Busoni saw music as connected to culture. To discuss music was to discuss all of the arts: “In his courses he not only cared about the instrument or the music, but always aimed at the totality of the arts and of humanity. So the lessons were a bit in all areas: from the literary to the philosophical to the aesthetic to the moral-social. And even more than with the spoken word, he loved to spread his knowledge and advise and guide you through epistolary correspondence, which is often a very minor aspect of pedagogy.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1_31",
      "id": "fn1_31"
    }
  }, [_vm._v("31")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The visual and plastic arts were especially important to Busoni, who encouraged his students to think of music in spatial terms."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1_32",
      "id": "fn1_32"
    }
  }, [_vm._v("32")])]), _vm._v(" In addition, he stressed the importance of the visual presentation of scores as part of the complete artwork.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Busoni’s aesthetic thoughts also formed an integral part of the conversations, and none of his students left without being familiar with his texts and ideas. He imparted a vision of music that he hoped would guide students’ aesthetic and technical decisions. In this way he communicated avant-garde and experimentalist thoughts about electronic instruments and the expansion of the tonal system. During student gatherings, he discussed his idiosyncratic ideas about music and sometimes read from his libretti or aesthetic texts as a form of instruction. Some of his students’ personal copies of Busoni’s writings, replete with personal annotations, have survived, thereby offering glimpses into what they gleaned from the text."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1_33",
      "id": "fn1_33"
    }
  }, [_vm._v("33")])]), _vm._v(" His writings also provide a vivid glimpse into some of the topics he must have discussed with his pupils.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Busoni’s "), _c('i', [_vm._v("Entwurf einer neuen Ästhetik der Tonkunst")]), _vm._v(" starts with a vision of abstract music in nature before moving to a more tangible discussion of the art of composing. He did not propose any methods, claiming that music was abstract, free, and limitless, like nature itself, in contradistinction to the other arts that were fettered by the imitation of text or image: “Music was born free, and to win freedom is its destiny. It will become the most complete of all reflexes of nature by reason of its untrammeled immateriality.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1_34",
      "id": "fn1_34"
    }
  }, [_vm._v("34")])]), _vm._v(" Instead, in a series of aphoristic sections, he poses suggestive possibilities that can be applied in numerous ways."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1_35",
      "id": "fn1_35"
    }
  }, [_vm._v("35")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("Throughout his writings, Busoni stressed that the human artwork should reflect music in nature through style, content, and form. According to Busoni, the essence of music, also called “Ur-Musik” and “Eternal harmony” in his writings, was an unheard source of music resounding in the vibrating universe that provided germinal material for all compositions. Weindel likened it to "), _c('i', [_vm._v("musica mundana")]), _vm._v(", and Crispin notes its existence outside time and its similarity to nature."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1_36",
      "id": "fn1_36"
    }
  }, [_vm._v("36")]), _vm._v(" The composer’s job, according to Busoni, was that of a prophet—to divine the mysteries of music in nature and to translate them into audible sounds. For that reason, he did not believe that art music could be truly original. In phrases reminiscent of the harmony of the spheres, he claimed that everything already exists in the vibrating universe—all scales and all combinations of sounds. The clearer the vision of true music, the better the translation and the more perfect the artwork, which he felt should be stylistically inclusive, thus reflecting the oneness of the styles in nature.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Busoni’s theory of musical oneness had important ramifications for his teachings on stylistic pluralism and the exploration of new scales and harmonies. He argued that since music is pure tone and all-encompassing in its primordial state, audible music should embrace all scales, harmonies, and styles of music. It should not be subjected to stylistic, historical, and genre divisions, which he claimed limited musical possibilities: “The time has come to recognize the whole phenomenon of music as a ‘oneness’ and no longer split it up according to its purpose, form, and sound-medium. It should be recognized from two premises exclusively, that of its content and that of its quality.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1_37",
      "id": "fn1_37"
    }
  }, [_vm._v("37")])]), _vm._v(" He did not encourage his students to forge a new style of music, which he believed would age quickly, nor to imitate the new styles of any contemporaries, but rather to embrace the stylistic characteristics of all the compositions they admired and to combine them, reflecting the multiplicity of musics in the sounding universe: “I believe one should attempt to put into one’s own music all that is assimilable of the composers one admires most and loves best. That is a sensible procedure, and a better tribute than uncritical veneration. Surely better than to ape a style and then set this up as the exclusive model for others.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1_38",
      "id": "fn1_38"
    }
  }, [_vm._v("38")])]), _vm._v(" He especially urged his mentees not to get caught up in the styles of the present. As he wrote to Jarnach, “One has to laugh, people have increasingly closed vision. They understand the value of the present, but not one second beyond that.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1_39",
      "id": "fn1_39"
    }
  }, [_vm._v("39")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("Busoni’s vision extended to scalar systems and instrumental sounds. He embraced the newest ideas about instruments, scales and music organization, suggesting they could be combined with the scales and instruments of the past and present."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1_40",
      "id": "fn1_40"
    }
  }, [_vm._v("40")]), _vm._v(" In particular, he talked about the possibilities of microtonal scales and new divisions of the octave as a reflection of the unlimited possibilities of music. He helped his students dream of new sounds beyond traditional acoustic ones. In particular, he talked about Thaddeus Cahill’s electronic telharmonium."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1_41",
      "id": "fn1_41"
    }
  }, [_vm._v("41")])]), _vm._v(" In practice, he also experimented with polytonality, music without bar lines, and new scales.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Because of Busoni’s views about the role of the composer as a diviner of inaudible music already in existence, he communicated countercultural views about originality to his students. His theory of Young Classicality reached maturity just after World War I, even if the roots of the theory were germinating already at the beginning of the twentieth century."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1_42",
      "id": "fn1_42"
    }
  }, [_vm._v("42")])]), _vm._v(" Young Classicality is not primarily a looking back to the past, but a fusion of past musical experiments with current ones to create new and unique forms: “By ‘Young Classicism’ I mean the mastery, the sifting and the turning to account of all the gains of previous experiments and their inclusion in strong and beautiful forms. This art will be old and new at the same time.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1_43",
      "id": "fn1_43"
    }
  }, [_vm._v("43")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As Fleet notes, Busoni was part of a larger trend of composers and authors (especially from "), _c('i', [_vm._v("the Jung-Wien")]), _vm._v(" movement) in Central Europe seeking to situate their works within historical traditions."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1_44",
      "id": "fn1_44"
    }
  }, [_vm._v("44")])]), _vm._v(" With a sense of youthful optimism, he believed that art was continually evolving to greater perfection, even as he elevated melody and thin textures."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1_45",
      "id": "fn1_45"
    }
  }, [_vm._v("45")])]), _vm._v(" He believed that what is truly classical will never age, and that it is characterized by timeless compositional traits (e.g., counterpoint), solid but unique forms, objectivity, and stylistic plurality.")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("Unlike many of his contemporaries, Schoenberg included, Busoni did not place a high value on originality. In a dialogue with Dieren, he claimed that the possibility of originality was doubtful, at best, and was certainly not the main goal of artwork: “Originality is a strange thing. Ponder it as you will, it is deceptive, fugitive. An intractable, elusive quality. A creative artist should not be consciously occupied with it.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1_46",
      "id": "fn1_46"
    }
  }, [_vm._v("46")])]), _vm._v(" Great compositions did not need to be new, but rather, of high quality, according to Busoni. Thus it was not a philosophical or aesthetic problem for Busoni and his "), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("students to create transcriptions or to borrow from and build upon previous compositions."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1_47",
      "id": "fn1_47"
    }
  }, [_vm._v("47")]), _vm._v(" He illustrated this process of musical evolution using the model of his own "), _c('i', [_vm._v("Fantasia contrappuntistica")]), _vm._v(", BV 256 (1910, 1912, 1922), which many of his composition students heard, and which was a completion of Bach’s "), _c('i', [_vm._v("Die Kunst der Fuge")]), _vm._v(", BWV 1080, coupled with new added material, including an introductory fantasia."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1_48",
      "id": "fn1_48"
    }
  }, [_vm._v("48")])]), _vm._v(" Busoni considered the work his own, even despite the reuse of Bach’s material:")]), _vm._v(" "), _c('p', {
    staticClass: "quote"
  }, [_vm._v("There is no new and old. Only known and not yet known. Of these, it seems to me that the known still forms by far the smaller part. A "), _c('i', [_vm._v("Fantasia Contrappuntistica")]), _vm._v(" was the first item on the program of 19th January. This work grew out of the attempt to complete J. S. Bach’s last unfinished fugue. It is a study. (Every self-portrait of Rembrandt’s is a study; every work is a study for the next one; every life’s work a study for those who come after.) The Bach fragment is planned on four fugue subjects, of which two are complete and the third commenced. The fragment breaks off when the three of these meet together for the first time, but the “development” of these three themes is lacking.… The fourth subject, on the other hand, had to be a completely new creation; there was no clue as to its character.… The old does not yield to the new but to the better."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1_49",
      "id": "fn1_49"
    }
  }, [_vm._v("49")])])]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("Busoni particularly discouraged working measure to measure; he also preferred to evaluate complete compositions. For this reason, he liked to hold irregular lessons separated by rather large spans of time, as Guerrini remembers:")]), _vm._v(" "), _c('p', {
    staticClass: "quote"
  }, [_vm._v("The primary condition imposed by the Maestro to his disciples was to bring to a lesson a certain amount of work. He did not admit (I think of the composition student of today) students that came with a folio of eight to sixteen bars. One went to class maybe once a month, but with a finished work, it was one time a sonata, or a symphonic piece, or a scene from an opera. This is because the lesson consisted of, and “had to consist of,” above all, an aesthetic discussion between Master and disciple. Indeed, the Maestro almost always started with the resolve not to get into questioning technique; therefore—he said—“the aesthetic result can justify use of all technical means.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1_50",
      "id": "fn1_50"
    }
  }, [_vm._v("50")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Busoni claimed that every composition should begin with an overarching vision for that particular work and that it could be informed by human experience. The vision, in turn, had to be translated into audible musical ideas that are then arranged into complete works of art reflecting the ideals of “abstract music”:"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1_51",
      "id": "fn1_51"
    }
  }, [_vm._v("51")])]), _vm._v(" “First comes the idea, then the conception, or one "), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("seeks for it, then follows the execution.”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1_52",
      "id": "fn1_52"
    }
  }, [_vm._v("52")]), _vm._v(" He taught that the vision should determine the formal structure of a piece—and not traditional forms taken from the "), _c('i', [_vm._v("Formenlehre")]), _vm._v(" tradition. While traditional forms played an important role in the majority of composition instruction at the time, for Busoni they only held historical interest. He called for strong and beautiful forms derived organically from opening themes, but sought them through a melding of forms normally kept separate, such as fantasia, sonata, palindrome, and variation, for instance. He idealized unique forms and instructed his students to strive for the same: “I am a worshipper of form! I have remained sufficiently a Latin for that. But I demand—no! the organism of art demands—that every idea fashions its own form for itself; the organism—not I—revolts against having one single form for all ideas.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1_53",
      "id": "fn1_53"
    }
  }, [_vm._v("53")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Busoni frequently modeled form after architectural structures rather than traditional musical forms, which he considered too systematic. As an avid lover of architecture, he collected books with floor plans, created his own architectural drawings, and also discussed architecture with his students. In one conversation with his students, he reportedly stated: “Form in music can often be compared with form in architecture. Thus three-part form is analogous to the Greek temple. There are other Greek buildings that are not based on a central idea, but have decoration and motifs going right round, often in the form of a frieze in bas-relief depicting historical or mythological scenes, each one quite different, but all united on the same plane.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1_54",
      "id": "fn1_54"
    }
  }, [_vm._v("54")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the Germanic tradition, the symphony was considered the crowning genre. By the mid-1910s, however, Busoni began to view opera, or some combination of music, scenery, and vocalization, as the highest art form. He envisioned a complete musical work in which the visual and drama explicate what is happening musically and provide a context for stylistic pluralism."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1_55",
      "id": "fn1_55"
    }
  }, [_vm._v("55")])]), _vm._v(" For him, opera most closely approached music in nature because it invited many different styles of music and because it could transport the listener out of the everyday through supernatural subjects."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1_56",
      "id": "fn1_56"
    }
  }, [_vm._v("56")])])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("HOW BUSONI TAUGHT COMPOSITION: PERFORMANCE AS INSTRUCTION AND AN AVOIDANCE OF ROUTINE")])]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Busoni’s instruction was not always esoteric and idealistic. For the composer, music was also to be heard, and performance and listening were integral parts of the compositional process. Thus he also encouraged free improvisation as part of the creative process. In addition, he often demonstrated at the piano. Once students had created pieces, he sometimes made them perform them, even if they were not professional musicians. In his Berlin master class, he had students create piano transcriptions of their compositions for performance. In addition, students attended performances of new music. He sponsored concerts in his home to which he invited students, and he also directed an orchestra concert series in Berlin from 1902 to 1909 for the purpose of promoting new music. During the Berlin master class, on November 2, 1921, he revived the practice of educating through concert music with a program of both old and new music:")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Sibelius, Symphony no. 5 in E-Flat Major, op. 82")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Monteverdi, Assorted Madrigals")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Beethoven, Symphony no. 3 in E-Flat Major, op. 55 (“Eroica”)")])]), _c('p', {
    staticClass: "poem"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("Busoni, Suite from Mozart’s "), _c('i', [_vm._v("Idomeneo")]), _vm._v(", K. 366"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1_57",
      "id": "fn1_57"
    }
  }, [_vm._v("57")])]), _vm._v(" "), _c('p', {
    staticClass: "indentt"
  }, [_vm._v("He had an insatiable curiosity for the unknown—older music and modern music—and he tried to instill that curiosity in his pupils as well. As Dieren remembers, he could not rest until he had programmed pieces that he found interesting."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1_58",
      "id": "fn1_58"
    }
  }, [_vm._v("58")])]), _vm._v(" His students also attended concerts of his own music when the pieces were finished, even if Busoni was reticent to show his own works in progress.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If there was anything predictable about his teaching, it was that of unpredictability. One never knew what he would talk about during the social hours and he did not follow a set and incremental course of assignments. Whatever impressed him or was on his mind would be brought up. This pedagogical style dovetailed with his own view of composition, which, he believed, should be unsystematic. According to Busoni, the creator should not follow any laws, but rather create anew his own each time: “But I think in this way about music: that every case should be a new case, an ‘exception.’ "), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("That every problem, once solved, should experience no repeated attempts at solution.”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1_59",
      "id": "fn1_59"
    }
  }, [_vm._v("59")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He criticized systematization as deficient and impoverished; Wagner’s system of leitmotifs thus received scathing criticisms from him as formulaic, even if he admired some of his orchestrations. For Busoni, routine was destructive. He claimed that the systematic transformed the masterpiece into little more than a mass-produced commodity. For one who strongly criticized writing music for money, and who held an otherworldly vision of music, this was a scornful criticism. In particular, he criticized routine as practiced in schools and institutions as detrimental to true art: “Routine transforms the Temple into a factory. It destroys all creativeness. For creation means bringing form out of the void. But routine is the factory for mass production. It is ‘poetry made to order.’ It prevails because it suits the generality. It flourishes in the theatre, in the orchestra, with virtuosi and in the ‘Schools of Art,’ that is to say those institutions which are arranged excellently for the maintenance of the teachers.” "), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1_60",
      "id": "fn1_60"
    }
  }, [_vm._v("60")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If Busoni was unpredictable in what he spoke about, he also seemed paradoxical to those who knew him. Hardly anything was black and white for him, so seeming or actual contradictions abounded in what he said. For instance, he had a strong antipathy for Wagner, not least because of his “routine” use of leitmotif technique. He might refer to him in a positive light, however, when discussing orchestration, and he also liked "), _c('i', [_vm._v("Parsifal")]), _vm._v("."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1_61",
      "id": "fn1_61"
    }
  }, [_vm._v("61")])]), _vm._v(" It was up to students to try to reconcile things that seemed dialectically opposed on the surface but that were logically synthesized in Busoni’s mind.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("COMPARISON OF TEACHING STYLES AND METHODS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Busoni’s unsystematic teaching style, which focused on aesthetic ideas rather than the material of music, was unconventional at the time, as a brief comparison with the pedagogical methods of his contemporaries and near contemporaries illustrates. Because he had largely concentrated on concertizing and teaching piano early on, the majority of his composition teaching activities took place after he reached the age of forty (in the years 1906–1924). For that reason, Nadia Boulanger and Arnold Schoenberg, both of whom were slightly younger yet who began teaching "), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("seriously around the same time as Busoni, provide comparative examples. The fact that Schoenberg succeeded Busoni in leading a Berlin composition master class at the Akademie der Künste in 1925 strengthens the comparison."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1_62",
      "id": "fn1_62"
    }
  }, [_vm._v("62")]), _vm._v(" Although Boulanger and Schoenberg, like Busoni, considered the masterpieces to be central to instruction, and also recognized the importance of the individuality of each student, style and technique were the main foundations of their composition instruction."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1_63",
      "id": "fn1_63"
    }
  }, [_vm._v("63")])]), _vm._v(" So was regular systematic training.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Boulanger believed that technique was a foundation upon which students could discover personal style. She thus insisted students systematically study and practice basic technical skills, such as counterpoint, harmony, score reading, or figured bass, until they had completely mastered the subjects."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1_64",
      "id": "fn1_64"
    }
  }, [_vm._v("64")])]), _vm._v(" Additionally, she required students of all ability levels to take remedial courses if she perceived deficiencies. Virgil Thomson remembers that her goal was solid technique: “Her teaching of the musical techniques is … full of rigor, while her toleration of expressive and stylistic variety in composition is virtually infinite.” "), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1_65",
      "id": "fn1_65"
    }
  }, [_vm._v("65")])]), _vm._v(" Stylistic variety was a byproduct that she not only tolerated but also embraced, within some bounds. She had definite stylistic ideals closely aligned with French Neoclassical ideals, such that some of her students adopted similar stylistic approaches. Matthew Mugmon has argued that her tolerance of Austro-Germanic music after Beethoven was limited. In particular, she disliked the twelve-tone music of Schoenberg even while favoring the music of Igor Stravinsky."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1_66",
      "id": "fn1_66"
    }
  }, [_vm._v("66")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Students remember that it took six to eight hours per day just to prepare for the lessons with Boulanger, which consisted largely of abstract exercises. Philip Glass, for instance (who had already trained with a Boulanger pupil in America), had to go back to the basics of harmony and counterpoint when he studied with Boulanger for two years (1963–1965). He states that all the students took part in regularly scheduled instruction with her and with her assistant, Mademoiselle Dieudonné: “You took three classes with her a week. One was a private class, the second was the class you took with Mademoiselle Dieudonné, which was also private. Then there was a third class called the Wednesday Class, which was a general class of all of her students who were with her at the time.” "), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1_67",
      "id": "fn1_67"
    }
  }, [_vm._v("67")])]), _vm._v(" The most challenging Black Thursday classes, “by invitation only,” consisted of six to eight students "), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("and met for three hours. Subjects varied but often included assignments in which the goal was to recreate exact harmonizations by the masters without having prior knowledge of the pieces. Boulanger also gave composition lessons privately, and, according to Virgil Thomson, they consisted largely of score critique with Boulanger at the piano: “The lessons take place with the teacher at the piano, the student in a chair at her right. She reads the score before her silently at first, then little by little begins to comment, spontaneously admiring here and there a detail of musical syntax or sound, expressing temporary reservations about another. Suddenly she will start playing (and perfectly, for she is a fabulous sight-reader) some passage that she needs to hear out loud or that she wishes the student to hear as illustration to her remarks.” "), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1_68",
      "id": "fn1_68"
    }
  }, [_vm._v("68")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Of particular contrast to Busoni’s approach was Boulanger’s attention to detail. While Busoni focused on meta-suggestions and rewrote pieces away from the piano, Boulanger focused on specific concrete technical problems at the piano."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1_69",
      "id": "fn1_69"
    }
  }, [_vm._v("69")])]), _vm._v(" Joel Feigin remembers that Boulanger emphasized craft and how to move notes around and that she taught voice leading through harmony."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1_70",
      "id": "fn1_70"
    }
  }, [_vm._v("70")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Like Boulanger, Schoenberg, who succeeded Busoni as master class instructor at the Akademie der Künste in 1925, regularly taught the basics of harmony and counterpoint to his students, insisting that they establish a firm foundation before branching off into free composition. During one of his earlier teaching positions, when he first began instructing Alban Berg and Anton Webern as part of the "), _c('i', [_vm._v("Freies Konservatorium")]), _vm._v(", which was started by reform pedagogue Eugenie Schwarzwald in the facilities of a girls’ school in October 1904, Schoenberg reportedly oriented harmony training after Simon Sechter and used Johann Joseph Fux for counterpoint."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1_71",
      "id": "fn1_71"
    }
  }, [_vm._v("71")])]), _vm._v(" Instruction began with three years of harmony and counterpoint. His own "), _c('i', [_vm._v("Harmonielehre")]), _vm._v(" (1911), which was not intended to spell out the rules of correct writing but to explain the logic underlying tonal harmony, was born from his experiences as a teacher. Moreover, the "), _c('i', [_vm._v("Formenlehre")]), _vm._v(" tradition based on Adolf Bernhard Marx’s writings was integral to Schoenberg’s teaching."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1_72",
      "id": "fn1_72"
    }
  }, [_vm._v("72")])]), _vm._v(" Free composition assignments included three- and four-voice choral arrangements and four- and five-voice double fugues. He insisted that mere technique was not enough to make someone great, but it was "), _c('i', [_vm._v("necessary")]), _vm._v(" for greatness, and he made sure his students had a firm "), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("technical foundation."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1_73",
      "id": "fn1_73"
    }
  }, [_vm._v("73")]), _vm._v(" In his Berlin master class, Schoenberg reportedly also included detailed assignments in music analysis and critiqued his students’ works. Marc Blitzstein (1905–1964), who studied orchestration, counterpoint, and free composition with Schoenberg in Berlin for about five months, maintains that Schoenberg was “married” to his theories, which he taught in his master classes, and that he severely criticized works that went beyond his own theories and Germanic aesthetic ideals."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1_74",
      "id": "fn1_74"
    }
  }, [_vm._v("74")])]), _vm._v(" He took a very “left-brained” approach, with an interest, above all, in the process or the working out of theories. The class analyses of pieces like Mahler’s Symphony no. 6 in A Minor (“Tragische”) and "), _c('i', [_vm._v("Das Lied von der Erde")]), _vm._v(", along with Schoenberg’s Wind Quintet op. 26, consisted largely of parsing the structure apart from any musical or sonorous considerations. Blitzstein remembers looking at many diagrams and schemes, for instance, that Schoenberg used to create his Quintet."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1_75",
      "id": "fn1_75"
    }
  }, [_vm._v("75")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("While many contemporaneous pedagogues drilled technique into their students, they also encouraged learning from the great masterpieces, but they did so through traditional analytical means. Boulanger, in particular, wanted students to have a good understanding of tradition and how their compositions fit into that tradition. Lennox Berkeley, claiming that exposure to the music of the masters helped develop personal taste and an understanding of form, summarizes:"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1_76",
      "id": "fn1_76"
    }
  }, [_vm._v("76")])]), _vm._v(" “She was an inspiring force, and her inspiration consisted in making us aware of the necessity of acquiring the technique which is indispensible for a composer.… Apart from that, she helped us to form our own tastes by insisting that we had to know music by composers of the past in depth; on this foundation she could help us to develop our sense of form.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1_77",
      "id": "fn1_77"
    }
  }, [_vm._v("77")])]), _vm._v(" She had her classes analyze the masterpieces and she presented material topically, rather than chronologically. For instance, she devoted one season to analyzing the cantatas of Bach and one to the Mozart concerti."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1_78",
      "id": "fn1_78"
    }
  }, [_vm._v("78")])]), _vm._v(" In Boulanger’s lessons, she taught technical skills using the great masters as reference, but with a reverence lacking in Busoni’s teaching. Bach’s counterpoint, according to Elliott Carter, was held as a standard to which Boulanger’s students aspired. To do it the same way Bach did was an accomplishment. Altering Bach would have been unthinkable."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1_79",
      "id": "fn1_79"
    }
  }, [_vm._v("79")])])]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("The basis of Schoenberg’s teaching was also the music of the masters. Schoenberg insisted that his students be thoroughly familiar with musical "), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("masterpieces through analysis in order to understand how their compositions related to tradition and differed from it. He wanted his students to understand how historical composers tackled the problems of working with and shaping the materials of music, and then to come up with their own novel solutions. Busoni, by contrast, wanted his disciples to revise and build upon the musics of the past. Whereas Schoenberg utilized analysis for the sake of revolution and originality, Busoni was interested in evolution:")])]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }), _c('p', {
    staticClass: "quote"
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("Often, a young man who wants to study with me expects to be taught in musical modernism. But he experiences a disappointment. Because in his compositions I usually recognize the absence of an adequate background. Superficially investigating I unveil the cause: the student’s knowledge of musical literature offers the aspects of Swiss cheese—almost more holes than cheese. Then I ask the following question: “If you wanted to build an aeroplane, would you venture to invent and construct by yourself every detail of which it is composed, or would you not better first try to acknowledge what all men did who designed aeroplanes before you? Don’t you think the same idea is correct in music?”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1_80",
      "id": "fn1_80"
    }
  }, [_vm._v("80")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Despite fundamental differences with regard to technique and analysis of the masters, similarities can also be observed. As with Busoni’s students, so also with Boulanger’s and Schoenberg’s, lessons extended beyond the confines of official classes to social events. Schoenberg, Busoni, and Boulanger were concerned about their students as individuals, and the students became their friends. Berg helped Schoenberg with details related to his move and an American pupil reportedly taught Boulanger to drive, while Busoni’s pupils helped him with editions, piano reductions, rehearsals, and issues related to his final illness. Boulanger, like Busoni, promoted her students as well, introducing Aaron Copland to Serge Koussevitzky, for instance, who later performed his music.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In addition, Schoenberg, Boulanger, and Busoni all insisted that students should always start with a vision for a complete piece. However, Schoenberg’s and Boulanger’s visions were musical ones, even while Busoni’s was initially an aesthetic one. Schoenberg stated, like Busoni, that it is detrimental to plot out a few measures per day without a larger plan for the piece: “A composer must not compose two or eight or sixteen measures today and again tomorrow and so on until the work seemed to "), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("be finished, but should conceive a composition as a totality, in one single act of inspiration. Intoxicated by his idea, he should write down as much as he could, not caring for the little details. They could be added, or carried out later.”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1_81",
      "id": "fn1_81"
    }
  }, [_vm._v("81")]), _vm._v(" Boulanger, for her part, insisted that a composition needed to have "), _c('i', [_vm._v("la grande ligne")]), _vm._v(", a term which no one knows how to translate, but which has something to do with linear and organic unfolding. Although it is not clear that this "), _c('i', [_vm._v("grande ligne")]), _vm._v(" needed to be completely conceived before a piece was started, it was a purely musical conception."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1_82",
      "id": "fn1_82"
    }
  }, [_vm._v("82")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For Boulanger, performance was also an important part of instruction. She had her students conduct, sing, and play, but in a pedantic way, as a means of gaining mastery over musical material. For his part, Busoni taught through performance in his new music concerts in Berlin from 1902 to 1909. He also insisted that student compositions be performed (often in piano reductions) in his Berlin master class.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Busoni’s pedagogical approach was spontaneous and focused on ideology, as opposed to musical material. This was blatantly different than the teaching style of his contemporaries. Moreover, it went against the grain of most of the instructional treatises of the age, which focus on techniques for combining the materials of music. Composition treatises or method books usually covered the topics of harmony, counterpoint, and/or form methodically and in detail. Sometimes the topics are covered comprehensively in multi-volume methods by single authors. Other times, authors focus on a single topic. Popular texts at the time included Johann Joseph Fux for counterpoint and Simon Sechter for harmony. Hector Berlioz was seen as a model for orchestration and A. B. Marx for form."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1_83",
      "id": "fn1_83"
    }
  }, [_vm._v("83")])]), _vm._v(" Before meeting Busoni, Jean Sibelius worked through the comprehensive four-volume "), _c('i', [_vm._v("Lehrbuch der musikalischen Komposition")]), _vm._v(" by Johann Christian Lobe, which progresses incrementally from basic concepts, such as the treatment of diatonic harmony, part writing, motive formation, and forms (vol. 1), to instrumentation (vol. 2), counterpoint (vol. 3), and opera composition (vol. 4)."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1_84",
      "id": "fn1_84"
    }
  }, [_vm._v("84")])]), _vm._v(" Like Busoni, Lobe relies heavily on exemplary compositions to teach compositional technique. He also upholds Mozart as the quintessential example for opera and Bach for counterpoint. Haydn, Mozart, and Beethoven feature prominently in the volume on harmony and motive formation and Berlioz serves as a model for orchestration. However, Lobe’s emphasis is on the treatment of music material, and his presentation of "), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_vm._v("ideas is fairly methodical. His volume on orchestration, for instance, lists each instrument individually—systematically discussing range, timbral qualities, and uses. Rather than communicating color as an integral fiber of compositional identity, Lobe urges students to practice doublings first in keyboard score before considering timbre and color."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1_85",
      "id": "fn1_85"
    }
  }, [_vm._v("85")]), _vm._v(" In volume 1, he covers scales, cadences, and phrasing, for instance. Information about aesthetics is relegated to an ancillary closing section entitled “addendum,” in which he includes compositional maxims. For his part, Varèse chose to have his early composition students in Berlin work through harmony books by Ludwig Thuille/Rudolf Louis and Schoenberg, both of which offer compositional advice through presentations of basic principles of harmony and voice leading. The texts might have appealed to Varèse, because they feature innovative treatments of chromaticism or dissonance resolution. Thuille, for instance, offers the usual advice about triadic harmony and voice leading. However, he also includes information about complex chromatic modulations that stretched the boundaries of tonality, such as movement from A minor to C-sharp minor."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1_86",
      "id": "fn1_86"
    }
  }, [_vm._v("86")])]), _vm._v(" In addition, his book contains extensive information about chromatic chords. Schoenberg, who sought in his text to teach composition through harmony, covers consonance and dissonance, modes, voice leading, cadences, modulation, and non-harmonic tones, among other topics. Schoenberg’s sometimes discursive but almost always deep writing style interweaves philosophy of music with guidelines for treating the material of music. Yet unlike Busoni, Schoenberg’s end goal is not to communicate esoteric aesthetic ideas but practical compositional principles. He stresses throughout that he is interested in tones and their combinations. He avoids figured bass realizations—asking students instead to devise their own harmonic progressions, phrases, and forms—a difference, he claims, that mandates the fusion of harmony and composition from the beginning.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Busoni’s teaching style was thus fundamentally different from some of the most influential contemporaneous teachers. Moreover, it did not reflect the thorough, systematic training in most composition method books in circulation at the time. While Boulanger and Schoenberg focused on the materials of music and systematically conveyed a thorough technical foundation, Busoni focused on aesthetic ideas and connected music to the other arts. He left the fundamentals up to others and inspired his "), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_vm._v("students with esoteric ideas. Lessons were intermittent, and there were no assignments that built up in an incremental manner. Although he used the music of the masters as teaching tools, he did not consider it sacrosanct. He was always ready to point out sections of tremendous competence in Bach’s music, but he encouraged his students to rewrite the music as well. He had no distinctive pedagogical method of his own, as he eschewed routine and tried to do things differently every time. Busoni thought his students could figure out the fundamentals on their own as their vision of what music should be like directed them.")])]), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_c('p', {
    staticClass: "h1"
  }, [_vm._v("CLOSING THOUGHTS")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_vm._v("Despite the idiosyncrasy of Busoni’s approach, it had a profound effect on many of the youths who studied with him. At the same time, the students also had a positive effect on Busoni. To the end of his life, he surrounded himself with young people, and he enjoyed exchanging ideas with them. He was enthused by their ideas and their energy—their ideas reminded him to never become complacent: “The fact, that both as an artist and as a human being, I prefer looking forward rather than backward, explains why I like having young people around me. So may it continue until the end—because if that ceases to be the case, it is very sad.”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1_87",
      "id": "fn1_87"
    }
  }, [_vm._v("87")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("According to Guerrini, Busoni not only basked in the presence of youth, but he also had young people’s best interests in mind, even if this meant stating what they did not want to hear: “Busoni’s love for young people was the true love of teacher, the one that in order to educate is not afraid to hurt. Ruthless criticism was in him the greatest sign of consideration and affection. For this reason, only a few of his disciples followed him, then, in life. In general, the young people of his time did not understand him or were averse to him, in part, because [they were] intolerant of his brusque means of educating.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1_88",
      "id": "fn1_88"
    }
  }, [_vm._v("88")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To those who followed him, he became a father figure—a priest—revealing the secrets of art. He encouraged them to tap previously unexplored creative regions in their minds and souls. Thus some statements by Busoni pupils must be read with reservation, as it was common for mentees to put their teachers on pedestals, especially in Germany, where hagiography and an obsession with greatness colored the way of writing about "), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_vm._v("well-respected figures. Moreover, Busoni, like Schoenberg, consciously cultivated a sense of authority. Schoenberg did this through the dogmatic assertion of his theories, and Busoni fostered an aura of otherworldliness, further contributing to the awe with which their students held them. As Levitz has already noted, although jovial and human during social hours, Busoni sometimes portrayed an air of authority during lessons by modeling his teaching behavior and style of communication on literary characters. For instance, he dialogued with his students like Mephistopheles had done with Faust, thereby assuming the role of the wise and all-knowing master."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1_89",
      "id": "fn1_89"
    }
  }, [_vm._v("89")]), _vm._v(" At times, he could be condescending and sarcastic.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Busoni never wanted his role as pedagogue to be pedantic; rather, he saw himself as a motivator and a visionary. He believed anyone could develop the technical craft of composition, but only those with true ability could understand the vision of music and how to translate that into the vision for an individual composition. He thus tried to bring out the best of the gifted and to help them develop their individual style, but he had little to offer the less talented or the beginner, except for his own charisma. While his pedagogical approach was not successful with all of his pupils, many claim that they were inspired by it. Moreover, although the styles of his students are so diverse that it is difficult to identify a stylistic school, it does not preclude the fact that Busoni’s idiosyncratic approach was meaningful and effective, leading to the development of a nexus of composers with a shared vision of music that influenced new trends in early twentieth-century music, including experimentalist ones. This nexus of students explores new sonorities, new ways of organizing sound, and stylistic heterogeneity, even as the students embraced a variety of musical and artistic traditi ons and reached toward a future of music that reflected their own appropriations of Busoni’s vision of the essence of music. In Stuckenschmidt’s words: “Pupils of his pupils continue to carry the flame that [Busoni] kindled in the distant past,” and it is the story of the kindling of the flame and the passing of the torch that unfolds in more detail in the following pages."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1_90",
      "id": "fn1_90"
    }
  }, [_vm._v("90")])])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("NOTES")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn1_1",
      "id": "rfn1_1"
    }
  }, [_vm._v("1")]), _vm._v(". I am grateful to Matthew Mugmon for his comments on an earlier version of "), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_vm._v("this chapter, as well as to Joel Feigin for sharing his memories of studies with Nadia Boulanger.")])]), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "page_38"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn1_2",
      "id": "rfn1_2"
    }
  }, [_vm._v("2")]), _vm._v(". Busoni, “Introduction to Bach Edition” (1915), in "), _c('i', [_vm._v("The Essence of Music and Other Papers")]), _vm._v(", trans. Rosamund Ley (1922; London: Salisbury Square, 1957), 99.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn1_3",
      "id": "rfn1_3"
    }
  }, [_vm._v("3")]), _vm._v(". “Hier ist der thematische Zusammenhang mit der Fuge offenbar: trotzdem hält ihn der Herausgeber für unbeabsichtigt; aber die beiden Motive sind aus demselben Geiste heraus geboren.” J. S. Bach, "), _c('i', [_vm._v("Das wohltemperierte Klavier")]), _vm._v(", vol. II, ed. Busoni (Leipzig: Breitkopf und Härtel, 1916), 10.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn1_4",
      "id": "rfn1_4"
    }
  }, [_vm._v("4")]), _vm._v(". Busoni, “Introduction to the Bach Edition” (1915), in "), _c('i', [_vm._v("The Essence of Music and Other Papers")]), _vm._v(", 98.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn1_5",
      "id": "rfn1_5"
    }
  }, [_vm._v("5")]), _vm._v(". Bach, "), _c('i', [_vm._v("Das wohltemperierte Klavier")]), _vm._v(", vol. II, ed. Busoni, 3.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn1_6",
      "id": "rfn1_6"
    }
  }, [_vm._v("6")]), _vm._v(". Ibid., 20.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn1_7",
      "id": "rfn1_7"
    }
  }, [_vm._v("7")]), _vm._v(". Ibid., 14.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn1_8",
      "id": "rfn1_8"
    }
  }, [_vm._v("8")]), _vm._v(". Ibid., 19.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn1_9",
      "id": "rfn1_9"
    }
  }, [_vm._v("9")]), _vm._v(". Busoni, “Aesthetik des Orchesters,” Staatsbibliothek zu Berlin, Preußischer Kulturbesitz, Musikabteilung mit Mendelssohn-Archiv, Mus. Nachl. F. Busoni, CI-135.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn1_10",
      "id": "rfn1_10"
    }
  }, [_vm._v("10")]), _vm._v(". “Beinahe unerforscht sind heute noch die Geheimnisse der Lage bei Mozart. Breite Demonstration: a) der Einfluss der Stimmführung auf die instrumentale Zeichnung; Mozart wendet doppelten Kontrapunkt häufig an; daher die frappanteste Erscheinung in seinen Partituren: die führende Stimme gleichzeitig ober- und unterhalb der Begleitung (oder umgekehrt); b) Seine Pedalnoten; c) die breite Lage bei den Streichern, beständiges Sorgen, einen freien Raum für die füllende Harmonie zu erhalten, d.h. Obertone der unteren Stimmen, unaufdringliche Hörner oder Fagotte. Ein wichtiger Moment: melodische Streicher gehen durch geschlossene Blaserakkorde; nie umgekehrt, denn Verdoppelung zum Zweck des Durchdringens sind Mozartfremd. Er wendet solche nur der Klangfarbe wegen an, (Flöte und Oboen—Flöte und Fagotte, u.s.w.) oder zum dynamischen Anwachsen des Themas.” Ibid.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn1_11",
      "id": "rfn1_11"
    }
  }, [_vm._v("11")]), _vm._v(". Gisella Selden-Goth, "), _c('i', [_vm._v("Ferruccio Busoni: Der Versuch eines Porträts")]), _vm._v(" (1922; Firenze: Leo S. Olschki, 1964), 130.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn1_12",
      "id": "rfn1_12"
    }
  }, [_vm._v("12")]), _vm._v(". Busoni, “The Theory of Orchestration,” (1905), in "), _c('i', [_vm._v("The Essence and Oneness of Music")]), _vm._v(", 35–36.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn1_13",
      "id": "rfn1_13"
    }
  }, [_vm._v("13")]), _vm._v(". Busoni encouraged Jarnach to study "), _c('i', [_vm._v("Le Nozze di Figaro")]), _vm._v(" in 1916. Busoni to Jarnach, April 4, 1916. Jarnach Nachlass, uncatalogued, Staatsbibliothek zu Berlin, Preußischer Kulturbesitz, Musikabteilung mit Mendelssohn-Archiv, N. Mus. Depos 56.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn1_14",
      "id": "rfn1_14"
    }
  }, [_vm._v("14")]), _vm._v(". Busoni, “An Attempt at a Definition of Melody” (1913), in "), _c('i', [_vm._v("The Essence of Music and Other Papers")]), _vm._v(", 33.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn1_15",
      "id": "rfn1_15"
    }
  }, [_vm._v("15")]), _vm._v(". H. H. Stuckenschmidt, "), _c('i', [_vm._v("Ferruccio Busoni: “Chronicle of a European")]), _vm._v(" [1967],” trans. Sandra Morris (New York: St. Martin’s, 1970), 200–201. Geiser was one of Busoni’s Berlin masterclass pupils. For more information about Geiser, consult Tamara Levitz, “Teaching New Classicality: Busoni’s Master Class in Composition, 1921–24” (PhD diss., University of Rochester, 1993), 229–230.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn1_16",
      "id": "rfn1_16"
    }
  }, [_vm._v("16")]), _vm._v(". Guerrini to Busoni, February 3, 1924, Berlin Staatsbibliothek zu Berlin, Preußischer Kulturbesitz, Musikabteilung mit Mendelssohn-Archiv, Mus. Nachl. F. Busoni, BII, 1998. Guerrini still addresses Busoni as “my dearest master” and "), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_vm._v("writes that he has not forgotten Busoni’s advice. A letter dated February 6, 1923, from Guerrini states that he meditated on Busoni’s every word. In addition, his most recent works, he claimed, had profited from his advice. Staatsbibliothek zu Berlin, Preußischer Kulturbesitz, Musikabteilung mit Mendelssohn-Archiv, Mus. Nachl. F. Busoni, BII, 1998. Guerrini, "), _c('i', [_vm._v("Ferruccio Busoni: La vita, la figura, l’opera")]), _vm._v(" (Firenze: Casa Editrice Monsalvato, 1944), 232.")])]), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "page_39"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn1_17",
      "id": "rfn1_17"
    }
  }, [_vm._v("17")]), _vm._v(". Busoni, “Tagesbuch, Staatsbibliothek zu Berlin, Preussischer Kulturbesitz, Musikabteilung mit Mendelssohn Archiv, N. Mus. Nachl. 4, 98.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn1_18",
      "id": "rfn1_18"
    }
  }, [_vm._v("18")]), _vm._v(". Busoni to Dieren, April 26, 1913, Staatsbibliothek zu Berlin, Preussischer Kulturbesitz, Musikabteilung mit Mendelssohn Archiv, N. Mus. Bachl. F. Busoni, BI, 525. Perhaps these discussions were important for Dieren’s only surviving opera, "), _c('i', [_vm._v("The Tailor")]), _vm._v(" (1917–1930).")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn1_19",
      "id": "rfn1_19"
    }
  }, [_vm._v("19")]), _vm._v(". Dieren to Busoni, April 18, 1913, Staatsbibliothek zu Berlin, Preussischer Kulturbesitz, Musikabteilung mit Mendelssohn Archiv, N. Mus. Nachl. F. Busoni, BII, 1449.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn1_20",
      "id": "rfn1_20"
    }
  }, [_vm._v("20")]), _vm._v(". Busoni to Dieren, October 26, 1919, Staatsbibliothek zu Berlin, Preussischer Kulturbesitz, Musikabteilung mit Mendelssohn Archiv, N. Mus. Nachl. F. Busoni, BI, 526.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn1_21",
      "id": "rfn1_21"
    }
  }, [_vm._v("21")]), _vm._v(". Busoni, notes for Gruenberg’s compositions in progress, private collection of Joan Gruenberg Cominos, Martinez, CA.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn1_22",
      "id": "rfn1_22"
    }
  }, [_vm._v("22")]), _vm._v(". Busoni avoided everyday topics of politics or economics and created a utopian otherworldly atmosphere that put many students in awe of him.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn1_23",
      "id": "rfn1_23"
    }
  }, [_vm._v("23")]), _vm._v(". Busoni owned several copies of the complete works by Goethe as well as Nietzsche’s "), _c('i', [_vm._v("Als sprach Zarathustra")]), _vm._v(" (1904), "), _c('i', [_vm._v("Der Fall Wagner")]), _vm._v(" (1888), and "), _c('i', [_vm._v("Die Geburt der Tragödie")]), _vm._v(" (1907). See Max Perl, Antiquariat, "), _c('i', [_vm._v("Bibliothek Ferruccio Busoni: Werke der Weltliteratur in schönen Gesamtausgaben und Erstdrucken; Illustrierte Bücher aller Jahrhunderte")]), _vm._v(", Auction 96, March 30–31, 1925 (Berlin: Max Perl, 1925).")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn1_24",
      "id": "rfn1_24"
    }
  }, [_vm._v("24")]), _vm._v(". Consult the following sources for more information: Walter Frisch, “Music and Jugendstil,” "), _c('i', [_vm._v("Critical Inquiry")]), _vm._v(" 17:1 (Autumn 1990), 138–161; Andrew McCredie, ed., "), _c('i', [_vm._v("Art Nouveau and Jugendstil and the Music of the Early 20th Century")]), _vm._v(", Miscellanea Musicologica, Adelaide Studies in Musicology, vol. 13 (Adelaide: University of Adelaide, 1984); Hans Hollander, "), _c('i', [_vm._v("Musik und Jugendstil")]), _vm._v(" (Zurich: Atlantis-Verlag, 1975).")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn1_25",
      "id": "rfn1_25"
    }
  }, [_vm._v("25")]), _vm._v(". Busoni, “Routine,” "), _c('i', [_vm._v("Pan")]), _vm._v(" 1:20 (August 16, 1911), 654–655; Busoni, “Schönberg-Matinée,” "), _c('i', [_vm._v("Pan")]), _vm._v(" 2:11 (February 11, 1912), 327–330; Busoni, “Selbst-Rezension,” "), _c('i', [_vm._v("Pan")]), _vm._v(" 2: 11 (February 1, 1912), 327–330.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn1_26",
      "id": "rfn1_26"
    }
  }, [_vm._v("26")]), _vm._v(". Bernard van Dieren, "), _c('i', [_vm._v("Down among the Dead Men and Other Essays")]), _vm._v(" (London: Oxford University Press, 1935), 65–66.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn1_27",
      "id": "rfn1_27"
    }
  }, [_vm._v("27")]), _vm._v(". Ibid., 65")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn1_28",
      "id": "rfn1_28"
    }
  }, [_vm._v("28")]), _vm._v(". The use of the masculine pronoun is intentional here. Busoni doubted the intellectual and artistic potential of women in the professional realm. He specifically disliked females in authority positions and those who came across as strong or intellectual. He considered some women childish and underdeveloped socially, psychologically, and intellectually. At the same time, he felt bereft without their graces. For additional information of Busoni’s views about women, consult Levitz, “Teaching New Classicality,” 117–118; Knyt, “Ferruccio Busoni and the "), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_vm._v("New England Conservatory: Piano Pedagogue in the Making,” "), _c('i', [_vm._v("American Music")]), _vm._v(" (31:3), 292.")])]), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "page_40"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn1_29",
      "id": "rfn1_29"
    }
  }, [_vm._v("29")]), _vm._v(". Petri, “How Ferruccio Busoni Taught: An Interview with the Distinguished Dutch Pianist,” interview by Friede F. Rothe, "), _c('i', [_vm._v("Etude")]), _vm._v(" 58 (October 1940), 710.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn1_30",
      "id": "rfn1_30"
    }
  }, [_vm._v("30")]), _vm._v(". Dieren, "), _c('i', [_vm._v("Down among the Dead Men and Other Essays")]), _vm._v(", 68.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn1_31",
      "id": "rfn1_31"
    }
  }, [_vm._v("31")]), _vm._v(". “Nei suoi corsi d’insegnamento egli non curava soltanto lo strumento o la musica, mireva sempre alla totalità dell’arte e dell’umanità. Perciò la lezioni si svolgevano un po’ in tutti i settori: da quello letterario a quello filosofico, da quello estetico a quello morale-sociale. E più ancora che con la parola detta, egli amò propagare il suo sapere e consigliare e guidare attraverso corrispondenze epistolare, che sono spesso dei veri piccoli Trattati di pedagogia.” Guerrini, "), _c('i', [_vm._v("Ferruccio Busoni")]), _vm._v(", 233.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn1_32",
      "id": "rfn1_32"
    }
  }, [_vm._v("32")]), _vm._v(". Levitz, “Teaching New Classicality,” 303.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn1_33",
      "id": "rfn1_33"
    }
  }, [_vm._v("33")]), _vm._v(". For instance, Edgard Varèse’s personal copy of the "), _c('i', [_vm._v("Entwurf einer neuen Ästhetik der Tonkunst")]), _vm._v(" is housed at the Harry Ransom Humanities Research Center at the University of Texas at Austin. Louis Gruenberg’s copy can be found in the private collection of Joan Gruenberg Cominos. Arnold Schoenberg also was influenced by the text, as evident by his personal annotated copy of it. Busoni, "), _c('i', [_vm._v("Entwurf einer neuen Aesthetik der Tonkunst")]), _vm._v(", facsimile of the 1916 edition with annotations by Schoenberg (Frankfurt: Insel, 1974).")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn1_34",
      "id": "rfn1_34"
    }
  }, [_vm._v("34")]), _vm._v(". Busoni, "), _c('i', [_vm._v("Sketch of a New Esthetic of Music")]), _vm._v(" (1907), trans. Dr. Th. Baker (New York: Schirmer, 1911), 5.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn1_35",
      "id": "rfn1_35"
    }
  }, [_vm._v("35")]), _vm._v(". For a fuller vision of Busoni’s views about absolute music and program music, consult Erinn Knyt, “Ferruccio Busoni and the Absolute in Music: Form, Nature and Idee,” "), _c('i', [_vm._v("Journal of the Royal Musical Association")]), _vm._v(" 137:1 (May 2012), 35–69.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn1_36",
      "id": "rfn1_36"
    }
  }, [_vm._v("36")]), _vm._v(". Martina Weindel, "), _c('i', [_vm._v("Ferruccio Busonis Ästhetik in seinen Briefen und Schriften")]), _vm._v(", ed. Richard Schaal (Wilhelmshaven: Heinrichsofen-Bücher, 1996); Judith Michelle Crispin, "), _c('i', [_vm._v("The Esoteric Musical Tradition of Ferruccio Busoni and Its Reinvigoration in the Music of Larry Sitsky: The Operas Doktor Faust and the Golem")]), _vm._v(", preface by Larry Sitsky (Lewiston, ME: Edwin Mellen Press, 2007), 23–25. See also Knyt, “Ferruccio Busoni and the Absolute in Music.”")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn1_37",
      "id": "rfn1_37"
    }
  }, [_vm._v("37")]), _vm._v(". Busoni, “The Essence and Oneness of Music,” in "), _c('i', [_vm._v("The Essence of Music and Other Papers")]), _vm._v(", 1.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn1_38",
      "id": "rfn1_38"
    }
  }, [_vm._v("38")]), _vm._v(". Dieren, "), _c('i', [_vm._v("Down among the Dead Men and Other Essays")]), _vm._v(", 76.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn1_39",
      "id": "rfn1_39"
    }
  }, [_vm._v("39")]), _vm._v(". Busoni, quoted in Levitz, “Teaching New Classicality,” 148. Based on a letter from Busoni to Jarnach, April 20, 1921, Staatsbibliothek zu Berlin, Preußischer Kulturbesitz, Musikabteilung mit Mendelssohn-Archiv, N. Mus. Depos. 56.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn1_40",
      "id": "rfn1_40"
    }
  }, [_vm._v("40")]), _vm._v(". Drafts leading up to Busoni’s "), _c('i', [_vm._v("Entwurf")]), _vm._v(" indicate that his experimental ideas about microtonal systems date back to at least 1888. Staatsbibliothek zu Berlin, Preußischer Kulturbesitz, Musikabteilung mit Mendelssohn-Archiv, Mus. Nachl. F. Busoni, CI, 115.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn1_41",
      "id": "rfn1_41"
    }
  }, [_vm._v("41")]), _vm._v(". Thaddeus Cahill (1867–1924) invented one of the first electronic instruments, the massive telharmonium. Although its size (seven tons) and cost (about $200,000) made the use and production of the instrument prohibitive, the idea of the instrument captured Busoni’s imagination. For more information about the instrument consult Reynold Weidenaar, "), _c('i', [_vm._v("Magic Music from the Telharmonium")]), _vm._v(" (London: Scarecrow "), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_vm._v("Press, 1995).")])]), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "page_41"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn1_42",
      "id": "rfn1_42"
    }
  }, [_vm._v("42")]), _vm._v(". Messing’s book deals more generally with neoclassicism and mentions Busoni’s views of young classicality in a small but well thought out analysis of Busoni’s aesthetic texts: Scott Messing, "), _c('i', [_vm._v("Neoclassicism in Music: From the Genesis of the Concept through the Schoenberg/Stravinsky Polemic")]), _vm._v(" (Rochester: University of Rochester Press, 1998), 65–74.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn1_43",
      "id": "rfn1_43"
    }
  }, [_vm._v("43")]), _vm._v(". Busoni, “Young Classicism” (Busoni to Paul Bekker, February 7, 1920), in "), _c('i', [_vm._v("The Essence of Music")]), _vm._v(", 20.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn1_44",
      "id": "rfn1_44"
    }
  }, [_vm._v("44")]), _vm._v(". Paul Fleet, "), _c('i', [_vm._v("Ferruccio Busoni: A Phenomenological Approach to His Music and Aesthetics")]), _vm._v(" (Cologne: Lambert Academic Publishing, 2009), 17–19. Young Vienna was a group of writers in Vienna at the turn of the twentieth century that turned from naturalism to symbolism or impressionism.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn1_45",
      "id": "rfn1_45"
    }
  }, [_vm._v("45")]), _vm._v(". Messing, "), _c('i', [_vm._v("Neoclassicism in Music")]), _vm._v(", 74.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn1_46",
      "id": "rfn1_46"
    }
  }, [_vm._v("46")]), _vm._v(". Dieren, "), _c('i', [_vm._v("Down among the Dead Men and Other Essays")]), _vm._v(", 77.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn1_47",
      "id": "rfn1_47"
    }
  }, [_vm._v("47")]), _vm._v(". True, Schoenberg encouraged transcriptions as a means to learn about music and to make it more accessible. However, unlike Busoni, he was offended by the idea that a transcription could be better than the original. See Erinn Knyt, “How I Compose: Ferruccio Busoni’s Views about Invention, Quotation, and the Compositional Process,” "), _c('i', [_vm._v("Journal of Musicology")]), _vm._v(" 27:2 (Spring 2010) 224–263. Levitz also discusses the role of transcription in Busoni’s composition master class, in “Teaching New Classicality,” 171–174.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn1_48",
      "id": "rfn1_48"
    }
  }, [_vm._v("48")]), _vm._v(". Busoni created several versions of this piece. The 1912 version is shortened considerably, and the 1922 version is scored for two pianos. The piece combines Busoni’s freely adapted and completed version of Bach’s "), _c('i', [_vm._v("Die Kunst der Fuge")]), _vm._v(" and a modified version of his own piano elegy no. 3. The titles of the three versions are as follows: "), _c('i', [_vm._v("Fantasia contrappuntistica")]), _vm._v(" ("), _c('i', [_vm._v("Preludio al corale “Gloria al Signore nel Cieli” e Fuga a quattro soggetti obbligati sopra un frammento di Bach)")]), _vm._v(" (1910); "), _c('i', [_vm._v("Fantasia contrappuntistica: Kleine Ausgabe")]), _vm._v(" ("), _c('i', [_vm._v("Choral-Vorspiel und Fuge über ein Bachsches Fragment")]), _vm._v(" (1912); and "), _c('i', [_vm._v("Fantasia contrappuntistica")]), _vm._v(" ("), _c('i', [_vm._v("Choral Variationen über “Ehre sei Gott in der Höhe” gefolgt von einer Quadrupel-Fuge über ein Bachsches Fragment: für Zwei Klaviere")]), _vm._v(") (1922). For comparisons of the three versions, consult Larry Sitsky, "), _c('i', [_vm._v("Busoni and the Piano: The Works, the Writings and the Recordings")]), _vm._v(", 2nd ed., Distinguished Reprints, no. 3 (Hillsdale, NY: Pendragon Press, 2009), 139–161, and Antony Beaumont, "), _c('i', [_vm._v("Busoni the Composer")]), _vm._v(" (Bloomington: Indiana University Press, 1985), 160–177.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn1_49",
      "id": "rfn1_49"
    }
  }, [_vm._v("49")]), _vm._v(". Busoni, “Self Criticism” (1912), in "), _c('i', [_vm._v("The Essence and Oneness of Music")]), _vm._v(", 46–47, 50.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn1_50",
      "id": "rfn1_50"
    }
  }, [_vm._v("50")]), _vm._v(". “Prima condizione imposta dal Maestro ai discepoli, era quella di portare a lezione una certa quantità di lavoro. Egli non ammetteva (lo ricordino gli studenti di composizione di oggi) che ci si recasse a scuola col fogliolino delle otto e sedici battute. Si andasse a lezione magari una volta al mese, ma con un lavoro finito, fosse un Tempo di Sonata, o un pezzo sinfonico o una scena d’opera. Perché la lezione consisteva, ‘doveva consistere’ sopratutto in una discussione estetica fra Maestro e discepolo. Anzi il Maestro partiva quasi sempre dal proponimento di non voler entrare in questioni tecniche, poiché—diceva lui—‘il risultato estetico può giustificar l’impiego di tutti i mezzi tecnici.’ Pel contrappunto, non occorre dirlo, la pietra di "), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_vm._v("tutti i paragoni era Giov. Sebastiano Bach.” Guerrini, "), _c('i', [_vm._v("Ferruccio Busoni")]), _vm._v(", 233–234.")])]), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "page_42"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn1_51",
      "id": "rfn1_51"
    }
  }, [_vm._v("51")]), _vm._v(". For a more detailed explanation about Busoni’s compositional process, consult Knyt, “How I Compose: Ferruccio Busoni’s Views about Invention, Quotation, and the Compositional Process.”")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn1_52",
      "id": "rfn1_52"
    }
  }, [_vm._v("52")]), _vm._v(". Busoni, “How I Compose” (1907), in "), _c('i', [_vm._v("The Essence of Music and Other Papers")]), _vm._v(", 50–51.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn1_53",
      "id": "rfn1_53"
    }
  }, [_vm._v("53")]), _vm._v(". Busoni, “Open Letter to Hans Pfitzner” (1917), in "), _c('i', [_vm._v("The Essence of Music and Other Papers")]), _vm._v(", 18.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn1_54",
      "id": "rfn1_54"
    }
  }, [_vm._v("54")]), _vm._v(". Busoni, quoted in Stuckenschmidt, "), _c('i', [_vm._v("Ferruccio Busoni")]), _vm._v(", 181. That architecture and the architectural shaping of sound or composition was a frequent topic of his conversations is supported by many of his students and friends in their memoirs, diaries, and letters. It was a topic that brought him great joy, and it surfaces in many of his letters. In a letter to Hugo Leichtentritt, Busoni stated, for instance: “I am becoming increasingly convinced that musical forms feel the "), _c('i', [_vm._v("need")]), _vm._v(" to be moulded adjustably, according to content and motif; just as a building, according to its given purpose and terrain.” Busoni to Leichtentritt, September 21, 1918 in "), _c('i', [_vm._v("Selected Letters")]), _vm._v(", 274.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn1_55",
      "id": "rfn1_55"
    }
  }, [_vm._v("55")]), _vm._v(". Busoni, “The Essence and Oneness of Music,” in "), _c('i', [_vm._v("The Essence of Music and Other Papers")]), _vm._v(", 14.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn1_56",
      "id": "rfn1_56"
    }
  }, [_vm._v("56")]), _vm._v(". Busoni, “The Future of Opera” (1913), in "), _c('i', [_vm._v("The Essence of Music and Other Papers")]), _vm._v(", 39–40.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn1_57",
      "id": "rfn1_57"
    }
  }, [_vm._v("57")]), _vm._v(". Levitz, “Teaching New Classicality,” 154.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn1_58",
      "id": "rfn1_58"
    }
  }, [_vm._v("58")]), _vm._v(". Dieren, "), _c('i', [_vm._v("Down among the Dead Men and Other Essays")]), _vm._v(", 73.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn1_59",
      "id": "rfn1_59"
    }
  }, [_vm._v("59")]), _vm._v(". Busoni, “Routine” (1911), in "), _c('i', [_vm._v("The Essence of Music and Other Papers")]), _vm._v(", 184–185. Originally published without title in "), _c('i', [_vm._v("Pan")]), _vm._v(" 1:20 (August 16, 1911), 645ff.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn1_60",
      "id": "rfn1_60"
    }
  }, [_vm._v("60")]), _vm._v(". Busoni, “Routine” (1911), in "), _c('i', [_vm._v("The Essence of Music and Other Papers")]), _vm._v(", 185.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn1_61",
      "id": "rfn1_61"
    }
  }, [_vm._v("61")]), _vm._v(". Busoni’s views about "), _c('i', [_vm._v("Parsifal")]), _vm._v(" are preserved in a short unpublished essay in the Staatsbibliothek zu Berlin, Preußischer Kulturbesitz, Musikabteilung mit Mendelssohn-Archiv, Mus. Nachl. F. Busoni, CI, 19.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn1_62",
      "id": "rfn1_62"
    }
  }, [_vm._v("62")]), _vm._v(". It is worth noting that a revival of the master-apprentice model developed from European Guilds of the Middle Ages took place in Germany in the 1920s. This trend was modeled at the Bauhaus, where workshops were led by master craftsmen and artists. Busoni also favored the master-apprentice model by choosing the masterclass format over more standardized institutional instruction.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn1_63",
      "id": "rfn1_63"
    }
  }, [_vm._v("63")]), _vm._v(". For more information about Boulanger’s teaching, consult Don G. Campbell, "), _c('i', [_vm._v("Master Teacher: Nadia Boulanger")]), _vm._v(" (Washington, DC: Pastoral Press, 1984), 5.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn1_64",
      "id": "rfn1_64"
    }
  }, [_vm._v("64")]), _vm._v(". Boulanger taught from 1904 to 1979 and eventually gave up composition to devote herself to the life of a pedagogue. She gave instruction in counterpoint, harmony, organ, score reading, figured bass, and analysis in a number of institutions, including the Conservatoire Femina-Musica, the École Normale, the Conservatoire American in Fontainebleau, and the Conservatoire de Paris. Her assistant, Mademoiselle Dieudonné, taught ear training and score reading.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn1_65",
      "id": "rfn1_65"
    }
  }, [_vm._v("65")]), _vm._v(". Virgil Thomson, quoted in Alan Kendall, "), _c('i', [_vm._v("The Tender Tyrant: Nadia Boulanger, A Life Devoted to Music")]), _vm._v(" (London: Macdonald and Jane’s, 1976), 59.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn1_66",
      "id": "rfn1_66"
    }
  }, [_vm._v("66")]), _vm._v(". Matthew Mugmon, email to the author, March 23, 2014. See also Virgil Thomson, “‘Greatest Music Teacher’ at 75,” "), _c('i', [_vm._v("Music Educator’s Journal")]), _vm._v(" 49:1 (September-October "), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_vm._v("1962), 43.")])]), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "page_43"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn1_67",
      "id": "rfn1_67"
    }
  }, [_vm._v("67")]), _vm._v(". Ev Grimes, “Interview: Education,” in "), _c('i', [_vm._v("Writings on Glass: Essays, Interviews, Criticism")]), _vm._v(", ed. Richard Kostelanetz and Robert Flemming (New York: Schirmer Books, 1997), 30–31.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn1_68",
      "id": "rfn1_68"
    }
  }, [_vm._v("68")]), _vm._v(". Thomson, quoted in Alan Kendall, "), _c('i', [_vm._v("The Tender Tyrant: Nadia Boulanger, A Life Devoted to Music")]), _vm._v(" (London: Macdonald and Jane’s, 1976), 59.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn1_69",
      "id": "rfn1_69"
    }
  }, [_vm._v("69")]), _vm._v(". I am grateful to Matthew Mugmon for making this comparison explicit. Mugmon, email to the author, March 23, 2014.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn1_70",
      "id": "rfn1_70"
    }
  }, [_vm._v("70")]), _vm._v(". Joel Feigin, phone communication with the author, May 22, 2014.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn1_71",
      "id": "rfn1_71"
    }
  }, [_vm._v("71")]), _vm._v(". Eugenie Schwarzwald (1872–1940) was an Austrian author and pedagogue who was interested in providing quality education for girls. Simon Sechter (1788–1867) was a prolific composer. Sechter’s most important pedagogical text is "), _c('i', [_vm._v("Die richtige Folge der Grundharmonien")]), _vm._v(", a three-volume treatise on composition. Johann Joseph Fux (1660–1741) is the author of "), _c('i', [_vm._v("Gradus ad Parnassum")]), _vm._v(", one of the most influential books on Renaissance counterpoint.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn1_72",
      "id": "rfn1_72"
    }
  }, [_vm._v("72")]), _vm._v(". Ulrich Krämer, "), _c('i', [_vm._v("Alban Berg als Schüler Arnold Schönbergs: Quellenstudien und Analysen zum Frühwerk")]), _vm._v(", Alban Berg Studien, vol. 4, ed. Rudolf Stephan (Vienna: Universal Edition, 1996). Adolf Bernhard Marx (1795–1866) wrote an influential four-volume treatise about music composition that presented a systematic discussion of traditional forms: "), _c('i', [_vm._v("Die Lehre von der musikalischen Komposition")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn1_73",
      "id": "rfn1_73"
    }
  }, [_vm._v("73")]), _vm._v(". Schoenberg, “Problems in Teaching Art” (1911), in "), _c('i', [_vm._v("Style and Idea: Selected Writings of Arnold Schoenberg")]), _vm._v(", ed. Leonard Stein, trans. Leo Black (New York: St. Martin’s, 1975).")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn1_74",
      "id": "rfn1_74"
    }
  }, [_vm._v("74")]), _vm._v(". Blitzstein stopped taking private composition lessons with Schoenberg after about three months, but continued attending the masterclass sessions.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn1_75",
      "id": "rfn1_75"
    }
  }, [_vm._v("75")]), _vm._v(". Marc Blitzstein to Nadia Boulanger, October 18, 1927, Bibliothèque Nationale de France, NLA 56, pieces 290–299. For a more comprehensive description of Blitzstein’s lessons with Schoenberg, consult Howard Pollack, "), _c('i', [_vm._v("Marc Blitzstein: His Life, His Work, His World")]), _vm._v(" (New York: Oxford University Press, 2012), 66–68.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn1_76",
      "id": "rfn1_76"
    }
  }, [_vm._v("76")]), _vm._v(". Lennox Berkeley (1903–1989) was an English composer who went to Paris in 1927 to study with Boulanger.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn1_77",
      "id": "rfn1_77"
    }
  }, [_vm._v("77")]), _vm._v(". Caroline Potter, "), _c('i', [_vm._v("Nadia and Lili Boulanger")]), _vm._v(" (Abingdon: Ashgate, 2008), 139. Also refer to Joseph Epstein, "), _c('i', [_vm._v("Masters: Portraits of Great Teachers")]), _vm._v(" (New York: Basic Books, 1981); Jérôme Spycket, "), _c('i', [_vm._v("Nadia Boulanger")]), _vm._v(", trans. M. M. Shriver (Stuyvesant, NY: Pendragon Press, 1992); Alan Kendall, "), _c('i', [_vm._v("The Tender Tyrant;")]), _vm._v(" Robin Orr, “A Note on Nadia Boulanger,” "), _c('i', [_vm._v("Musical Times")]), _vm._v(", 120:1642 (December 1979), 999; George Steiner, "), _c('i', [_vm._v("Lessons of the Masters")]), _vm._v(" (Cambridge, MA: Harvard University Press, 2003).")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn1_78",
      "id": "rfn1_78"
    }
  }, [_vm._v("78")]), _vm._v(". Ev Grimes, “Interview: Education,” in "), _c('i', [_vm._v("Writings on Glass")]), _vm._v(", 30–31.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn1_79",
      "id": "rfn1_79"
    }
  }, [_vm._v("79")]), _vm._v(". Elliott Carter and Jonathan W. Bernhard, “An Interview with Elliott Carter,” "), _c('i', [_vm._v("Perspectives of New Music")]), _vm._v(" 28:2 (Summer 1990), 199–200.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn1_80",
      "id": "rfn1_80"
    }
  }, [_vm._v("80")]), _vm._v(". Schoenberg, “Teaching and Modern Trends in Music” (1938), in "), _c('i', [_vm._v("Style and Idea")]), _vm._v(", 376–377.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn1_81",
      "id": "rfn1_81"
    }
  }, [_vm._v("81")]), _vm._v(". Schoenberg, “The Blessing of the Dressing” (1948), in "), _c('i', [_vm._v("Style and Idea")]), _vm._v(", 385.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn1_82",
      "id": "rfn1_82"
    }
  }, [_vm._v("82")]), _vm._v(". Matthew Mugmon, email to the author, March 23, 2014.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn1_83",
      "id": "rfn1_83"
    }
  }, [_vm._v("83")]), _vm._v(". See Johann Joseph Fux, "), _c('i', [_vm._v("Gradus ad Parnassum: sive Manuductio ad compositionem "), _c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_vm._v("musicæ regularem, methodo novâ ac certâ, nondum antè tam exacto ordine in lucem edita")])]), _c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_vm._v(" (Vienna: Joannis Petri van Ghelen, 1725); Simon Sechter, "), _c('i', [_vm._v("Die Grundsätze der musikalischen Komposition")]), _vm._v(" (Leipzig: Breitkopf und Härtel, 1853–1854); Adolf Bernhard Marx, "), _c('i', [_vm._v("Die Lehre von der musikalischen Komposition, praktisch-theoretisch, zum Selbstunterricht, oder als Leitfaden bei Privatunterweisung und öffentlichen Vorträgen")]), _vm._v(" (Leipzig: Breitkopf und Härtel, 1837); Hector Berlioz, "), _c('i', [_vm._v("Grand traité d’instrumentation et d’orchestration modernes")]), _vm._v(" (Paris: Schonenberger, c. 1844). For information about A. B. Marx and the Formenlehre tradition (as well as English translations of selected passages from his composition method), see Scott G. Burnham, "), _c('i', [_vm._v("Musical Form in the Age of Beethoven: Selected Writings on the Theory and Method")]), _vm._v(" (Cambridge: Cambridge University Press, 1997).")])]), _c('a', {
    attrs: {
      "id": "page_44"
    }
  }), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "page_44"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn1_84",
      "id": "rfn1_84"
    }
  }, [_vm._v("84")]), _vm._v(". J. C. Lobe, "), _c('i', [_vm._v("Lehrbuch der musikalischen Komposition")]), _vm._v(", 4 vols. (Leipzig: Breitkopf und Härtel, 1858–1867).")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn1_85",
      "id": "rfn1_85"
    }
  }, [_vm._v("85")]), _vm._v(". Busoni’s incomplete (and unpublished) orchestration treatise, by contrast, focuses on randomly organized aesthetic ideals of sound and color, and observations about effective orchestration techniques in the music of Mozart. The basics—such as instrument range, character, or capabilities, do not feature in the discussion.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn1_86",
      "id": "rfn1_86"
    }
  }, [_vm._v("86")]), _vm._v(". See Rudolf Louis and Ludwig Thuille, "), _c('i', [_vm._v("Harmonielehre")]), _vm._v(", 7th ed. (Stuttgart: Carl Gruninger, 1920), and Arnold Schoenberg, "), _c('i', [_vm._v("Theory of Harmony")]), _vm._v(" (1922), 3rd ed., trans. Roy E. Carter (Berkeley: University of California Press, 1983).")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn1_87",
      "id": "rfn1_87"
    }
  }, [_vm._v("87")]), _vm._v(". Busoni quoted in Stuckenschmidt, "), _c('i', [_vm._v("Ferruccio Busoni")]), _vm._v(", 178.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn1_88",
      "id": "rfn1_88"
    }
  }, [_vm._v("88")]), _vm._v(". “L’amore di Busoni per i giovani fu il vero amore di Maestro, quello ciò che per educare non teme di ferire. La critica più spietata era in lui il maggior segno di considerazione e di affetto. Per questo, soltanto pochi de suoi discepoli lo seguirono, poi, nella vita. In generale la gioventù del suo tempo non lo comprese o gli fu avversa, in parte proprio perché intollerante dei suoi rudi mezzi educatavi.” Guerrini, "), _c('i', [_vm._v("Ferruccio Busoni")]), _vm._v(", 236–237.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn1_89",
      "id": "rfn1_89"
    }
  }, [_vm._v("89")]), _vm._v(". Levitz, “Teaching New Classicality,” 139–142.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn1_90",
      "id": "rfn1_90"
    }
  }, [_vm._v("90")]), _vm._v(". Stuckenschmidt, "), _c('i', [_vm._v("Ferruccio Busoni")]), _vm._v(", 178.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e564a980","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/10_Chapter01.vue
// module id = 84
// module chunks = 0